import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteCommission } from '~/services/AgentHub/AgentService';

import { commissionQueryKeys } from './useListCommissions';

interface UseDeleteCommissionOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useDeleteCommission(options: UseDeleteCommissionOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (commissionId: string) => {
      return await deleteCommission(commissionId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: commissionQueryKeys.all });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
